const STATUS_LABELS: Record<string, string> = {
  ongoing: 'Em Andamento',
  finished: 'Finalizado',
};

export function formatSimulationStatus(status?: string): string {
  const cleaned = (status ?? '').trim().toLowerCase();
  if (!cleaned) {
    return '';
  }

  return STATUS_LABELS[cleaned] ?? status ?? '';
}
